import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import "./Dictionary.css";
import Photos from "./Photos";

export default function Dictionary(props){
    let [keyword, setKeyword] = useState (props.defaultKeyword);
    let [results, setResults] = useState (null);
    let [loaded, setLoaded] =useState (false);
    let [photos, setPhotos] = useState (null);


    function handleDictionaryResponse(response){
        setResults(response.data[0]);
    }

    function handlePexelsResponse(response){
        setPhotos(response.data.photos);

    }

    function search (){
        let apiUrl=`https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiUrl).then(handleDictionaryResponse);


        let pexelsApiKey=
        "563492ad6f917000010000017c10b68428f74656ac1f0021647e6169"
        let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
            let headers = { Authorization: `Bearer ${pexelsApiKey}` };
    axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);
  }
        
    
    
    
    function handleSubmit(event){
        event.preventDefault();
        search();
        


        
    }


    function handleKeywordChanage (event){
        setKeyword(event.target.value);
    }

        function load () {
            setLoaded (true);
            search();
        }

    
    if (loaded) {
         return (
        <div className="Dictionary">
            
            <section>
                <h1>What word do you want to look up?</h1>
            <form onSubmit={handleSubmit}>
                <input type="search" onChange={handleKeywordChanage} defaultValue={props.defaultKeyword}/>
                </form>
                </section>
                <Results results={results}/>
                <Photos photos={photos} />
            
        </div>
    );

         } else {
            load();
            return "loading;"
         } 
}